/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import cn from 'classnames';
import isArray from 'lodash/isArray';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import KeyValueMultiLineFieldPropTypes from './KeyValueMultiLineField.component.props';
import keyValueMultiLineFieldStyles from './KeyValueMultiLineField.component.styles';

/**
 * KeyValueMultiLineFieldComponent
 * @export
 * @class KeyValueMultiLineFieldComponent
 * @extends {React.Component<KeyValueMultiLineFieldComponentComposedProps, KeyValueMultiLineFieldComponentState>}
 */
export class KeyValueMultiLineFieldComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<KeyValueMultiLineFieldComponentProps>}
   * @memberof KeyValueMultiLineFieldComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`KeyValueMultiLineField`}
   * @memberof KeyValueMultiLineFieldComponent
   */
  static displayName = `KeyValueMultiLineField`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof KeyValueMultiLineFieldComponent
   */
  static propTypes = KeyValueMultiLineFieldPropTypes;

  /**
   * Render the component
   * @returns {React.Component} The rendered `<KeyValueMultiLineFieldComponent />`
   * @memberof KeyValueMultiLineFieldComponent
   */
  render() {
    const { classes, InputProps, GridItemProps, label, value } = this.props;
    const actualValue = isArray(value) ? value.join(`\n`) : value;
    return (
      <Grid item key={label} lg md sm xl xs={12} {...GridItemProps}>
        <TextField
          disabled
          fullWidth
          id={label}
          InputProps={{
            ...InputProps,
            classes: {
              inputMultiline: classes.inputMultiline,
              root: cn(classes.inputRoot, InputProps.classes.root),
            },
            value: actualValue,
          }}
          label={<I18n>{label}</I18n>}
          multiline
          rowsMax={5}
        />
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<KeyValueMultiLineFieldComponentProps>} */
const KeyValueMultiLineField = compose(withStyles(themeCreateInjectableStyles(keyValueMultiLineFieldStyles), { withTheme: true }))(
  KeyValueMultiLineFieldComponent,
);

export default KeyValueMultiLineField;
